/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AidDto,
  CreateForeignAidRequest,
  CreateMyNativeAidRequest,
  CreateNativeAidRequest,
  SimpleAidDto,
  UpdateAidAliasRequest,
  UpdateAidOobiRequest,
} from '../models/index';
import {
    AidDtoFromJSON,
    AidDtoToJSON,
    CreateForeignAidRequestFromJSON,
    CreateForeignAidRequestToJSON,
    CreateMyNativeAidRequestFromJSON,
    CreateMyNativeAidRequestToJSON,
    CreateNativeAidRequestFromJSON,
    CreateNativeAidRequestToJSON,
    SimpleAidDtoFromJSON,
    SimpleAidDtoToJSON,
    UpdateAidAliasRequestFromJSON,
    UpdateAidAliasRequestToJSON,
    UpdateAidOobiRequestFromJSON,
    UpdateAidOobiRequestToJSON,
} from '../models/index';

export interface DeleteNativeAidRequest {
    aid: string;
}

export interface FindAllNativeAidsRequest {
    userId?: string;
    orgId?: string;
    type?: string;
}

export interface FindForeignAidRequest {
    aid: string;
}

export interface FindNativeAidRequest {
    aid: string;
}

export interface SaveExternalAidRequest {
    createForeignAidRequest: CreateForeignAidRequest;
}

export interface SaveMyNativeAidRequest {
    createMyNativeAidRequest: CreateMyNativeAidRequest;
}

export interface SaveNativeAid1Request {
    createNativeAidRequest: CreateNativeAidRequest;
}

export interface SearchAidRequest {
    aid: string;
}

export interface SearchOobiByUserIdOrOrgIdRequest {
    orgId?: string;
}

export interface UpdateNativeAidAliasRequest {
    aid: string;
    updateAidAliasRequest: UpdateAidAliasRequest;
}

export interface UpdateNativeAidOobiRequest {
    aid: string;
    updateAidOobiRequest: UpdateAidOobiRequest;
}

/**
 * 
 */
export class AidControllerApi extends runtime.BaseAPI {

    /**
     * Delete native AID and stop monitoring
     * Delete native AID
     */
    async deleteNativeAidRaw(requestParameters: DeleteNativeAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['aid'] == null) {
            throw new runtime.RequiredError(
                'aid',
                'Required parameter "aid" was null or undefined when calling deleteNativeAid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/aid/native/{aid}`.replace(`{${"aid"}}`, encodeURIComponent(String(requestParameters['aid']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete native AID and stop monitoring
     * Delete native AID
     */
    async deleteNativeAid(requestParameters: DeleteNativeAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deleteNativeAidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all native AIDs
     */
    async findAllNativeAidsRaw(requestParameters: FindAllNativeAidsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AidDto>>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['orgId'] != null) {
            queryParameters['org_id'] = requestParameters['orgId'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/aid/native`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AidDtoFromJSON));
    }

    /**
     * Get all native AIDs
     */
    async findAllNativeAids(requestParameters: FindAllNativeAidsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AidDto>> {
        const response = await this.findAllNativeAidsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get external AID detail
     */
    async findForeignAidRaw(requestParameters: FindForeignAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['aid'] == null) {
            throw new runtime.RequiredError(
                'aid',
                'Required parameter "aid" was null or undefined when calling findForeignAid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/aid/external/{aid}`.replace(`{${"aid"}}`, encodeURIComponent(String(requestParameters['aid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Get external AID detail
     */
    async findForeignAid(requestParameters: FindForeignAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.findForeignAidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get native AID detail
     */
    async findNativeAidRaw(requestParameters: FindNativeAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['aid'] == null) {
            throw new runtime.RequiredError(
                'aid',
                'Required parameter "aid" was null or undefined when calling findNativeAid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/aid/native/{aid}`.replace(`{${"aid"}}`, encodeURIComponent(String(requestParameters['aid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Get native AID detail
     */
    async findNativeAid(requestParameters: FindNativeAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.findNativeAidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save external AID and start monitoring
     * Save external AID
     */
    async saveExternalAidRaw(requestParameters: SaveExternalAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimpleAidDto>> {
        if (requestParameters['createForeignAidRequest'] == null) {
            throw new runtime.RequiredError(
                'createForeignAidRequest',
                'Required parameter "createForeignAidRequest" was null or undefined when calling saveExternalAid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/aid/external/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateForeignAidRequestToJSON(requestParameters['createForeignAidRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimpleAidDtoFromJSON(jsonValue));
    }

    /**
     * Save external AID and start monitoring
     * Save external AID
     */
    async saveExternalAid(requestParameters: SaveExternalAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimpleAidDto> {
        const response = await this.saveExternalAidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save native AID and start monitoring
     * Save native AID
     */
    async saveMyNativeAidRaw(requestParameters: SaveMyNativeAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['createMyNativeAidRequest'] == null) {
            throw new runtime.RequiredError(
                'createMyNativeAidRequest',
                'Required parameter "createMyNativeAidRequest" was null or undefined when calling saveMyNativeAid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/aid/my-native/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMyNativeAidRequestToJSON(requestParameters['createMyNativeAidRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Save native AID and start monitoring
     * Save native AID
     */
    async saveMyNativeAid(requestParameters: SaveMyNativeAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.saveMyNativeAidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save native AID and start monitoring
     * Save native AID
     * @deprecated
     */
    async saveNativeAid1Raw(requestParameters: SaveNativeAid1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['createNativeAidRequest'] == null) {
            throw new runtime.RequiredError(
                'createNativeAidRequest',
                'Required parameter "createNativeAidRequest" was null or undefined when calling saveNativeAid1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/aid/native/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNativeAidRequestToJSON(requestParameters['createNativeAidRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Save native AID and start monitoring
     * Save native AID
     * @deprecated
     */
    async saveNativeAid1(requestParameters: SaveNativeAid1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.saveNativeAid1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search AID in both native and foreign AIDs
     */
    async searchAidRaw(requestParameters: SearchAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['aid'] == null) {
            throw new runtime.RequiredError(
                'aid',
                'Required parameter "aid" was null or undefined when calling searchAid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/aid/search/{aid}`.replace(`{${"aid"}}`, encodeURIComponent(String(requestParameters['aid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Search AID in both native and foreign AIDs
     */
    async searchAid(requestParameters: SearchAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.searchAidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint have only one parameter org_id and it is optional. If this parameter is not present, oobi from all aid for this user will be returned. If org_id is specified, both all oobi for aid for this user and all oobi for aid for this organization will be returned. The personal aids of other members of this organization will not be returned. A user is a member of an organization if he/she has an employee grant.
     * Search AID in both native and foreign AIDs
     */
    async searchOobiByUserIdOrOrgIdRaw(requestParameters: SearchOobiByUserIdOrOrgIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters['orgId'] != null) {
            queryParameters['org_id'] = requestParameters['orgId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/aid/search/oobi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * This endpoint have only one parameter org_id and it is optional. If this parameter is not present, oobi from all aid for this user will be returned. If org_id is specified, both all oobi for aid for this user and all oobi for aid for this organization will be returned. The personal aids of other members of this organization will not be returned. A user is a member of an organization if he/she has an employee grant.
     * Search AID in both native and foreign AIDs
     */
    async searchOobiByUserIdOrOrgId(requestParameters: SearchOobiByUserIdOrOrgIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.searchOobiByUserIdOrOrgIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update native AID Alias
     */
    async updateNativeAidAliasRaw(requestParameters: UpdateNativeAidAliasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['aid'] == null) {
            throw new runtime.RequiredError(
                'aid',
                'Required parameter "aid" was null or undefined when calling updateNativeAidAlias().'
            );
        }

        if (requestParameters['updateAidAliasRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAidAliasRequest',
                'Required parameter "updateAidAliasRequest" was null or undefined when calling updateNativeAidAlias().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/aid/native/{aid}/alias`.replace(`{${"aid"}}`, encodeURIComponent(String(requestParameters['aid']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAidAliasRequestToJSON(requestParameters['updateAidAliasRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Update native AID Alias
     */
    async updateNativeAidAlias(requestParameters: UpdateNativeAidAliasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.updateNativeAidAliasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update native AID OOBI
     */
    async updateNativeAidOobiRaw(requestParameters: UpdateNativeAidOobiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidDto>> {
        if (requestParameters['aid'] == null) {
            throw new runtime.RequiredError(
                'aid',
                'Required parameter "aid" was null or undefined when calling updateNativeAidOobi().'
            );
        }

        if (requestParameters['updateAidOobiRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAidOobiRequest',
                'Required parameter "updateAidOobiRequest" was null or undefined when calling updateNativeAidOobi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/aid/native/{aid}/oobi`.replace(`{${"aid"}}`, encodeURIComponent(String(requestParameters['aid']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAidOobiRequestToJSON(requestParameters['updateAidOobiRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidDtoFromJSON(jsonValue));
    }

    /**
     * Update native AID OOBI
     */
    async updateNativeAidOobi(requestParameters: UpdateNativeAidOobiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidDto> {
        const response = await this.updateNativeAidOobiRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
